var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.125 30.525C5.58287 32.725 6.17962 34.1921 7.325 35.2921C9.57037 36.575 12.0454 37.3079 14.6592 37.3079C28.5454 37.3079 38.4907 27.3625 38.4907 13.475C38.4907 10.8625 37.7579 8.3875 36.475 6.14213C34.825 4.85787 32.9907 4.30925 31.3421 4.125L27.125 12.7421C27.4921 13.6125 27.675 14.3454 28.0421 14.9421C29.0046 15.5829 29.9217 15.95 31.1579 16.225C30.7 23.65 24.6954 29.6079 17.225 29.975C16.9954 29.0579 16.6296 28.1421 16.125 27.225C15.3921 26.7204 14.8421 26.3546 14.1079 26.125L5.125 30.525Z",
    fill: "#47D870"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccept);
export default __webpack_public_path__ + "static/media/icon-accept.de9b0a0509d8d62ad813c11ff5de0629.svg";
export { ForwardRef as ReactComponent };